/* eslint-disable no-console */
import { messaging } from './projects/MyFirebase';

const vapidKey = process.env.REACT_APP_VAPID_KEY;

// Register service worker
async function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', {
        scope: '/',
      });
      console.log('Service Worker registered successfully:', registration);

      // Wait for service worker to be ready
      await navigator.serviceWorker.ready;
      console.log('Service Worker is ready');

      return registration;
    } catch (error) {
      console.error('Service Worker registration failed:', error);
      throw error;
    }
  } else {
    throw new Error('Service Worker not supported');
  }
}

// POST request to subscribe to push notifications
async function subscribeToNotifications(token, userAgent) {
  try {
    const response = await fetch('https://push.bahannonews.com/api/subscribers', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token: token,
        userAgent: userAgent,
      }),
    });

    // Check if the response is ok
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Parse the JSON response
    const data = await response.json();

    // Handle the response
    if (!data.error) {
      console.log('Success:', data.message);
      return data;
    } else {
      console.error('Error:', data.message);
      throw new Error(data.message);
    }
  } catch (error) {
    console.error('Fetch error:', error);
    throw error;
  }
}

function saveFcmOnDB(currentToken) {
  // const domainId = process.env.REACT_APP_FCM_DOMAIN_ID;
  // const domainSecret = process.env.REACT_APP_FCM_DOMAIN_SECRET;
  // const hash = md5(`${domainId}/${domainSecret}/${currentToken}`);
  // crypto
  //     .createHash('md5')
  //     .update(`${domainId}/${domainSecret}/${currentToken}`)
  //     .digest('hex');

  // AxiosAuth.get(`https://push.bikiran.com/api/save-fcm/${domainId}/${hash}/${currentToken}/`);

  subscribeToNotifications(currentToken, navigator.userAgent);
}

export const getTokenId = async (setTokenFound) => {
  let currentToken = '';

  if (messaging !== null) {
    try {
      // Ensure service worker is registered first
      await registerServiceWorker();

      // Request notification permission if not granted
      if (Notification.permission === 'default') {
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') {
          console.log('Notification permission denied');
          setTokenFound(false);
          return '';
        }
      } else if (Notification.permission === 'denied') {
        console.log('Notification permission was previously denied');
        setTokenFound(false);
        return '';
      }

      // Use Firebase compat method for getting token
      currentToken = await messaging.getToken({ vapidKey });
      if (currentToken) {
        setTokenFound(true);
        console.log('FCM Token received:', currentToken);
      } else {
        setTokenFound(false);
        console.log('No registration token available');
      }

      saveFcmOnDB(currentToken);
    } catch (error) {
      console.log('An error occurred while retrieving token. ', error);
      setTokenFound(false);
    }
  } else {
    console.log('Messaging is not available');
    setTokenFound(false);
  }

  return currentToken;
};

export const onMessageListener = () =>
  new Promise((resolve, reject) => {
    if (messaging !== null) {
      messaging.onMessage((payload) => {
        resolve(payload);
      });
    } else {
      reject(new Error('Messaging not Allowed'));
    }
  });
